var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { CaseStatus } from '@debbie/common/dist/cases';
import { c } from '@debbie/cortex/dist';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors';
import Checkbox from './Checkbox';
import Panel from './Panel';
import Modal from './Modal';
import { PlusSquare, X } from './Icons';
import Table from './Table';
import { selectVoucherTypes } from '@debbie/cortex/dist/economy/selectors';
import Button from './Button';
import Input from './Input';
import SearchInput from './SearchInput';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers';
const MergeCaseRules = (props) => {
    const { rules, onChange } = props;
    const lang = useSelector((s) => s.lang);
    const updateTypes = useSelector(selectUpdateTypes);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    useEffect(() => {
        if (!updateTypes) {
            c.updates.types();
        }
    }, []);
    return (React.createElement(Panel, { header: lang.navigation.settingsCaseMergeRules },
        React.createElement("p", null, lang.caseMergeRules.description),
        React.createElement(Checkbox, { onChange: (e) => onChange(Object.assign(Object.assign({}, rules), { preventMerge: e.target.checked })), checked: rules.preventMerge, placeholder: lang.caseMergeRules.preventMerge }),
        React.createElement(Checkbox, { onChange: (e) => onChange(Object.assign(Object.assign({}, rules), { hasActivePaymentPlan: e.target.checked ? null : false })), checked: rules.hasActivePaymentPlan === null, placeholder: lang.caseMergeRules.hasActivePaymentPlan }),
        React.createElement(Checkbox, { onChange: (e) => onChange(Object.assign(Object.assign({}, rules), { hasFoundation: e.target.checked ? null : false })), checked: rules.hasFoundation === null, placeholder: lang.caseMergeRules.hasFoundation }),
        React.createElement(Checkbox, { onChange: (e) => {
                if (e.target.checked) {
                    onChange(Object.assign(Object.assign({}, rules), { caseStatus: (rules.caseStatus || []).concat(CaseStatus.PENDING) }));
                }
                else {
                    onChange(Object.assign(Object.assign({}, rules), { caseStatus: (rules.caseStatus || []).filter((status) => status !== CaseStatus.PENDING) }));
                }
            }, checked: (rules.caseStatus || []).includes(CaseStatus.PENDING), placeholder: lang.caseMergeRules.caseStatusPending }),
        React.createElement(Checkbox, { onChange: (e) => {
                if (e.target.checked) {
                    onChange(Object.assign(Object.assign({}, rules), { caseStatus: (rules.caseStatus || []).concat(CaseStatus.VERIFIED) }));
                }
                else {
                    onChange(Object.assign(Object.assign({}, rules), { caseStatus: (rules.caseStatus || []).filter((status) => status !== CaseStatus.VERIFIED) }));
                }
            }, checked: (rules.caseStatus || []).includes(CaseStatus.VERIFIED), placeholder: lang.caseMergeRules.caseStatusVerified }),
        React.createElement(Checkbox, { onChange: (e) => {
                onChange(Object.assign(Object.assign({}, rules), { adjustVariableCaseVouchers: e.target.checked || undefined }));
            }, checked: rules.adjustVariableCaseVouchers, placeholder: lang.caseMergeRules.adjustVariableCaseVouchers }),
        React.createElement(CaseVoucherConstraints, { caseVoucherConstraints: rules.caseVoucherConstraints, onChange: (caseVoucherConstraints) => onChange(Object.assign(Object.assign({}, rules), { caseVoucherConstraints: caseVoucherConstraints })) }),
        React.createElement("h4", null, lang.caseMergeRules.doesNotHaveUpdateTypeIds),
        React.createElement(Select, { value: (rules.doesNotHaveUpdateTypeIds || []).map((updateTypeId) => {
                const updateType = updateTypesMap[updateTypeId];
                return {
                    label: lang.updateTypes[updateTypeId] ||
                        (updateType && updateType.label) ||
                        updateType,
                    value: updateTypeId,
                };
            }), isMulti: true, placeholder: lang.caseMergeRules.doesNotHaveUpdateTypeIds, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                value: updateType.updateTypeId,
            })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                const selected = val ? val.map((v) => v.value) : [];
                onChange(Object.assign(Object.assign({}, rules), { doesNotHaveUpdateTypeIds: selected }));
            }) }),
        React.createElement("h4", null, lang.caseMergeRules.doesHaveUpdateTypeIds),
        React.createElement(Select, { value: (rules.doesHaveUpdateTypeIds || []).map((updateTypeId) => {
                const updateType = updateTypesMap[updateTypeId];
                return {
                    label: lang.updateTypes[updateTypeId] ||
                        (updateType && updateType.label) ||
                        updateType,
                    value: updateTypeId,
                };
            }), isMulti: true, placeholder: lang.caseMergeRules.doesHaveUpdateTypeIds, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                value: updateType.updateTypeId,
            })), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                const selected = val ? val.map((v) => v.value) : [];
                onChange(Object.assign(Object.assign({}, rules), { doesHaveUpdateTypeIds: selected.length ? selected : undefined }));
            }) })));
};
export default MergeCaseRules;
const CaseVoucherConstraints = (props) => {
    const { caseVoucherConstraints, onChange } = props;
    const lang = useSelector((s) => s.lang);
    const voucherTypes = useSelector(selectVoucherTypes);
    useEffect(() => {
        if (!voucherTypes) {
            c.economy.getVoucherTypes();
        }
    }, []);
    const [newModalOpen, setNewModalOpen] = useState(false);
    return (React.createElement("div", null,
        React.createElement("h4", null,
            lang.caseMergeRules.caseVoucherConstraints,
            React.createElement(PlusSquare, { style: { cursor: 'pointer', float: 'right', fontSize: '1.3em' }, onClick: () => setNewModalOpen(!newModalOpen) })),
        React.createElement("p", null, lang.caseMergeRules.caseVoucherConstraintsDescription),
        caseVoucherConstraints && (React.createElement(Table, { zebra: true }, caseVoucherConstraints.map((caseVoucherConstraint, index) => {
            const voucherType = voucherTypes === null || voucherTypes === void 0 ? void 0 : voucherTypes.find((voucherType) => voucherType.voucherTypeId ===
                caseVoucherConstraint.voucherTypeId);
            return (React.createElement("tr", null,
                React.createElement("td", null, 
                // @ts-ignore
                lang.economyVoucherTypeLabels[caseVoucherConstraint.voucherTypeId] || (voucherType === null || voucherType === void 0 ? void 0 : voucherType.label)),
                React.createElement("td", null, typeof caseVoucherConstraint.timeConstraintInDays ===
                    'number'
                    ? `${caseVoucherConstraint.timeConstraintInDays} ${lang.caseMergeRules.caseVoucherConstraintsDays}`
                    : lang.caseMergeRules.caseVoucherConstraintsAllDays),
                React.createElement("td", null,
                    React.createElement(X, { style: {
                            cursor: 'pointer',
                            float: 'right',
                            fontSize: '1.3em',
                        }, onClick: () => {
                            onChange(caseVoucherConstraints.filter((_, i) => i !== index));
                        } }))));
        }))),
        newModalOpen && (React.createElement(AddCaseVoucherConstraint, { onToggle: () => setNewModalOpen(!newModalOpen), onAdd: (caseVoucherConstraint) => onChange(caseVoucherConstraints
                ? caseVoucherConstraints.concat(caseVoucherConstraint)
                : [caseVoucherConstraint]), caseVoucherConstraints: caseVoucherConstraints }))));
};
const AddCaseVoucherConstraint = (props) => {
    const lang = useSelector((s) => s.lang);
    const [voucherTypeId, setVoucherTypeId] = useState(null);
    const [days, setDays] = useState('');
    const voucherTypes = useSelector(selectVoucherTypes);
    const selectedVoucherType = voucherTypes === null || voucherTypes === void 0 ? void 0 : voucherTypes.find((voucherType) => voucherType.voucherTypeId === voucherTypeId);
    const parsedDays = !Number.isNaN(parseInt(days)) ? parseInt(days) : undefined;
    console.log(typeof parsedDays, parsedDays);
    return (React.createElement(Modal, { header: lang.caseMergeRules.addCaseVoucherConstraint, onToggle: props.onToggle, maxWidth: "500px" },
        React.createElement(SearchInput, { autofocus: true, searchAll: (q) => {
                var _a;
                const results = (_a = ((!q
                    ? voucherTypes
                    : voucherTypes === null || voucherTypes === void 0 ? void 0 : voucherTypes.filter((voucherType) => (JSON.stringify(voucherType) +
                        lang.economyVoucherTypeLabels[voucherType.voucherTypeId])
                        .toLocaleLowerCase()
                        .includes(q.toLocaleLowerCase()))) || [])) === null || _a === void 0 ? void 0 : _a.filter((voucherType) => [VoucherCategory.COST, VoucherCategory.COURTCOST].includes(
                // @ts-ignore
                voucherType.category) &&
                    !(props.caseVoucherConstraints || []).find((constraint) => constraint.voucherTypeId === voucherType.voucherTypeId)).map((voucherType) => ({
                    key: voucherType.voucherTypeId,
                    heading: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
                        (voucherType === null || voucherType === void 0 ? void 0 : voucherType.label),
                    // @ts-ignore
                    subheading: lang.economyCategories[voucherType.category],
                    returnData: voucherType.voucherTypeId,
                }));
                return results;
            }, onSelect: (voucherTypeId) => {
                setVoucherTypeId(voucherTypeId);
            }, onRemoveStatic: () => setVoucherTypeId(null), placeholder: lang.caseMergeRules.addCaseVoucherConstraintSelectVoucherType, static: selectedVoucherType
                ? lang.economyVoucherTypeLabels[selectedVoucherType.voucherTypeId] || (selectedVoucherType === null || selectedVoucherType === void 0 ? void 0 : selectedVoucherType.label)
                : undefined }),
        React.createElement(Input, { placeholder: lang.caseMergeRules.addCaseVoucherConstraintUniqueInDays, onChange: (e) => setDays(e.target.value), value: days || '', type: "number" }),
        React.createElement(Button, { block: true, disabled: !voucherTypeId, onClick: () => {
                props.onAdd({
                    voucherTypeId: voucherTypeId,
                    timeConstraintInDays: typeof parsedDays === 'number' ? parsedDays : undefined,
                });
                props.onToggle();
            } }, lang.caseMergeRules.addCaseVoucherConstraintAddButton)));
};
//# sourceMappingURL=MergeCaseRules.js.map